import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

const SvgBug = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill={baseColors.black}
                    d="M19.423 10.193h-3.461v-1.2a3.66 3.66 0 003.076-3.608v-.77a.577.577 0 00-1.153 0v.77c0 1.18-.822 2.171-1.924 2.432v-.509A.963.963 0 0015 6.347h-.577V4.23c0-1.213-.87-2.227-2.018-2.452l.43-.967A.577.577 0 1011.78.343l-.616 1.388H8.836L8.22.343a.577.577 0 00-1.055.469l.43.966a2.504 2.504 0 00-2.018 2.453v2.116H5a.963.963 0 00-.961.961v.51a2.504 2.504 0 01-1.924-2.433v-.77a.577.577 0 00-1.153 0v.77a3.66 3.66 0 003.077 3.608v1.2H.577a.577.577 0 000 1.154h3.462v1.2a3.66 3.66 0 00-3.077 3.607v.77a.577.577 0 001.153 0v-.77c0-1.18.822-2.17 1.923-2.432v.317A5.968 5.968 0 0010 20a5.968 5.968 0 005.961-5.961v-.317a2.504 2.504 0 011.923 2.432v.77a.577.577 0 001.154 0v-.77a3.66 3.66 0 00-3.077-3.608v-1.2h3.462a.577.577 0 000-1.153zM6.731 4.23c0-.742.604-1.346 1.346-1.346h3.846c.742 0 1.346.604 1.346 1.346v2.116H6.731V4.23zm8.077 9.808A4.813 4.813 0 0110 18.847a4.813 4.813 0 01-4.808-4.808V7.5h4.231v5.576a.577.577 0 001.154 0V7.501h4.23v6.538z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h20v20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgBug
